import { initZoomMotion } from '../../style/motion';
import { genComponentStyleHook, getArrowStyle, mergeToken, PresetColors, resetComponent, } from '../../theme';
const generatorTooltipPresetColor = token => {
    const { componentCls } = token;
    return PresetColors.reduce((previousValue, currentValue) => {
        const lightColor = token[`${currentValue}-6`];
        previousValue[`&${componentCls}-${currentValue}`] = {
            [`${componentCls}-inner`]: {
                backgroundColor: lightColor,
            },
            [`${componentCls}-arrow`]: {
                background: lightColor,
                '--antd-arrow-background-color': lightColor,
            },
        };
        return previousValue;
    }, {});
};
const genTooltipStyle = token => {
    const { componentCls, // ant-tooltip
    tooltipMaxWidth, tooltipColor, tooltipBg, tooltipBorderRadius, zIndexPopup, controlHeight, boxShadow, paddingSM, paddingXS, } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), { position: 'absolute', zIndex: zIndexPopup, display: 'block', '&': [{ width: 'max-content' }, { width: 'intrinsic' }], maxWidth: tooltipMaxWidth, visibility: 'visible', '&-hidden': {
                    display: 'none',
                }, '--antd-arrow-background-color': tooltipBg, 
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: controlHeight,
                    minHeight: controlHeight,
                    padding: `${paddingSM / 2}px ${paddingXS}px`,
                    color: tooltipColor,
                    textAlign: 'start',
                    textDecoration: 'none',
                    wordWrap: 'break-word',
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow,
                }, [`${componentCls}-content`]: {
                    position: 'relative',
                } }), generatorTooltipPresetColor(token)), { 
                // RTL
                '&-rtl': {
                    direction: 'rtl',
                } }),
        },
        // Arrow Style
        getArrowStyle(token, 'var(--antd-arrow-background-color)', ''),
    ];
};
// ============================== Export ==============================
export default (prefixCls, injectStyle) => {
    const useOriginHook = genComponentStyleHook('Tooltip', token => {
        // Popover use Tooltip as internal component. We do not need to handle this.
        if (injectStyle === false) {
            return [];
        }
        const { radiusBase, colorTextLightSolid, colorBgDefault } = token;
        const TooltipToken = mergeToken(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: radiusBase,
            tooltipBg: colorBgDefault,
        });
        return [genTooltipStyle(TooltipToken), initZoomMotion(token, 'zoom-big-fast')];
    }, ({ zIndexPopupBase, colorBgTooltipTmp }) => ({
        zIndexPopup: zIndexPopupBase + 70,
        colorBgDefault: colorBgTooltipTmp,
    }));
    return useOriginHook(prefixCls);
};
